import React from 'react';
import HabboImage from '../HabboImage';
import AddToCalendar from './AddToCalendar';
import {
    countdownLabel,
    dayKey,
    eventEndAt,
    eventLength,
    isLive,
    timeLabel,
    typeColor
} from './eventsPublic';

const shortDate = (value, zone) => {
    const key = dayKey(value, zone);
    return `${key.slice(8)}/${key.slice(5, 7)}/${key.slice(2, 4)}`;
};

function EventCard({ event, zone, className = '', muted = false, showCalendar = true, onClick }) {
    const live = isLive(event);
    const start = Date.parse(event.startAt);
    const soon = !live && Number.isFinite(start) && (start - Date.now()) < (6 * 3600000);

    const body = (
        <>
            <div className="flex items-stretch">
                <div className="border border-black bg-[#F8F9FA] text-center min-w-[110px] px-2 py-1 text-[11px] tracking-wide shadow-[0_2px_3px_rgba(6,19,25,0.25)]">
                    {live ? (
                        <b>Happening Now!</b>
                    ) : (
                        <>
                            {timeLabel(event.startAt, zone)}
                            {' - '}
                            {shortDate(event.startAt, zone)}
                        </>
                    )}
                </div>
                <div className="border border-l-0 border-black bg-gray-300 px-2 py-1 text-[11px] tracking-wide shadow-[0_2px_3px_rgba(6,19,25,0.25)]">
                    {eventLength(event)} mins
                </div>
                <div
                    title={`Win: ${event.win}`}
                    className="text-left truncate flex-1 border border-l-0 border-black bg-gold px-2 py-1 text-[11px] tracking-wide shadow-[0_2px_3px_rgba(6,19,25,0.25)]"
                >
                    Win: {event.win}
                </div>

                {showCalendar && <AddToCalendar event={event} variant="icon" />}
            </div>

            <div className="mt-2">
                <div className="font-['Jersey_10'] uppercase tracking-wide text-[24px] leading-none">
                    {event.name}
                </div>

                <div className="mt-3 grid items-center gap-x-2 gap-y-1 text-[12px] leading-normal [grid-template-columns:60px_150px]">
                    <div className="opacity-70 uppercase tracking-wide">Room</div>
                    <div className="truncate">{event.room}</div>

                    <div className="opacity-70 uppercase tracking-wide">Owner</div>
                    <div className="truncate">{event.owner}</div>

                    <div className="col-span-2 border-t border-black/20 mt-1"></div>

                    <div className="col-span-2 grid items-center [grid-template-columns:60px_150px] bg-black/5 px-1 py-1">
                        <div className="opacity-70 uppercase tracking-wide">Host</div>
                        <div className="truncate font-bold">{event.host}</div>
                    </div>
                </div>
            </div>

            <div className="flex items-center justify-between gap-2 border-t border-black/20 pt-2 text-[10px] uppercase tracking-wide opacity-70">
                <span className="truncate">
                    {timeLabel(event.startAt, zone)} to {timeLabel(eventEndAt(event), zone)} in {zone.replace(/_/g, ' ')}
                </span>
                {(live || soon) && (
                    <span className="shrink-0 font-bold">{live ? 'Live' : countdownLabel(event)}</span>
                )}
            </div>

            <HabboImage
                habbo={event.host}
                hotel="COM"
                gesture="sml"
                direction={4}
                head_direction={4}
                className="absolute right-2 bottom-[-20px]"
                alt=""
            />
        </>
    );

    const shell = [
        'border border-black/50 p-3 h-[190px] flex flex-col justify-between transition relative overflow-hidden text-left',
        live ? 'bg-green-200 border-green-900' : muted ? 'bg-[#ece4da] opacity-50 hover:opacity-100' : 'bg-[#ece4da]',
        onClick ? 'cursor-pointer hover:border-black' : 'cursor-default',
        className
    ].join(' ');

    const clickable = typeof onClick === 'function';

    return (
        <div
            className={shell}
            style={{ borderLeft: `4px solid ${typeColor(event.type)}` }}
            role={clickable ? 'button' : undefined}
            tabIndex={clickable ? 0 : undefined}
            onClick={clickable ? () => onClick(event) : undefined}
            onKeyDown={clickable ? (e) => { if (e.key === 'Enter') onClick(event); } : undefined}
        >
            {body}
        </div>
    );
}

export default EventCard;
